
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { FieldItemProps } from ".";
import { loading, fieldIndex } from "store/form";
import { FormItemProps } from "apis/form";

interface ApiFieldInputProps {
    formId: number;
    q?: string;
}

type ApiFieldOutputProps = OutputBaseProps<{ list: FieldItemProps[]; form?: FormItemProps; }>

export const apiFieldIndex = async ({ formId, ...data }: ApiFieldInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiFieldOutputProps>(`/api/form/${formId}/fields`, { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(fieldIndex({ data: res.data.list, form: res.data.form }));
    }
    return res;
};